import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardProps,
  Chip,
  Typography
} from '@mui/material'
import { useContext } from 'react'
import { generatePath, Link as RouterLink } from 'react-router-dom'

import { AppRoutes } from '../../models'
import { TwilioConversationsContext } from '../../providers'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import { RepairOrderWithRelated } from '../../sdk'
import { describeLicense, describeVehicleYMM } from '../../utils'
import { useChat } from '../ChatServices/useChat'
import { RepairOrderStatusChip } from '../SharedUI/RepairOrderStatusChip'

export const DviRepairOrderCard = ({
  repairOrder,
  ...cardProps
}: {
  repairOrder: RepairOrderWithRelated
} & CardProps) => {
  const { repairOrderStatuses } = useContext(AppContext)
  const { conversationUniqueNamesWithUnreadMessages } = useContext(
    TwilioConversationsContext
  )
  const { messages } = useChat(repairOrder.repairOrder!.id!)
  return (
    <Card
      sx={{
        border: '1px solid rgba(0, 0, 0, 0.24)',
        boxShadow: 0
      }}
      {...cardProps}>
      <CardActionArea
        component={RouterLink}
        to={generatePath(AppRoutes.DVI_SINGLE_JOB, {
          id: repairOrder.repairOrder!.id!
        })}>
        <CardHeader
          title={describeVehicleYMM(repairOrder.vehicle!.info!)}
          titleTypographyProps={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
          }}
          subheader={
            <>
              <Typography>
                RO ID: #{repairOrder.repairOrder!.localId!}
              </Typography>
              <RepairOrderStatusChip
                statuses={repairOrderStatuses}
                statusId={repairOrder.repairOrder!.info!.status}
              />
            </>
          }
          sx={{ '& .MuiCardHeader-content': { overflow: 'hidden' } }}
          action={
            <Chip
              size="small"
              color={
                conversationUniqueNamesWithUnreadMessages.includes(
                  repairOrder.repairOrder!.id!
                )
                  ? 'error'
                  : 'default'
              }
              label={messages.length}
            />
          }
        />
        <CardContent>
          <Typography>
            {describeLicense(repairOrder.vehicle!.info!)
              ? `Vehicle Plate: ${describeLicense(repairOrder.vehicle!.info!)}`
              : `License Plate Not Found`}
          </Typography>
          <Typography>
            Created: {repairOrder.repairOrder!.created?.toLocaleDateString()}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}
